export class RoleNames {
  public static readonly Administrator = 'Administrator';
  public static readonly Merchant = 'Merchant';
  public static readonly Shop = 'Shop';
}
